import { ModelMailTypes } from "@/type/core/models/models.types";
import { CALLBACK_URL_PARAM } from "@/utils/Constant";
import { Query, computePathWithQueries } from "@/utils/helpers/query-helper";

enum RoutePrefixes {
  EXTRANET = "/extranet",
  E2E = "/e2e",
}

export const ROUTES = {
  extranet: {
    home: {
      generate: (): string => RoutePrefixes.EXTRANET,
    },
    onboarding: {
      generate: (): string => `${RoutePrefixes.EXTRANET}/onboarding`,
    },
    onboardingStatus: {
      generate: (status: string): string =>
        `${RoutePrefixes.EXTRANET}/onboarding/${status}`,
    },
    cgu: {
      generate: (): string => `${RoutePrefixes.EXTRANET}/cgu`,
    },
    transactions: {
      details: {
        generate: (id: string): string =>
          `${RoutePrefixes.EXTRANET}/transaction/${id}`,
      },
      positioning: {
        generate: (): string => `${RoutePrefixes.EXTRANET}/positioning`,
      },
      resetPositioning: {
        generate: (transactionId: string, reset?: string): string =>
          `${RoutePrefixes.EXTRANET}/positioning/${transactionId}${
            reset ? `/${reset}` : ""
          }`,
      },
      signature: {
        generate: (): string => `${RoutePrefixes.EXTRANET}/signature`,
      },
      scellement: {
        generate: (): string => `${RoutePrefixes.EXTRANET}/scellement`,
      },
      process: {
        generate: (id: string): string =>
          `${RoutePrefixes.EXTRANET}/transaction/${id}/process`,
      },
    },
    menu: {
      account: {
        myInformations: {
          generate: (): string => `${RoutePrefixes.EXTRANET}/informations`,
        },
        mySignature: {
          generate: (): string =>
            `${RoutePrefixes.EXTRANET}/personal-signature`,
        },
        myPreferences: {
          generate: (): string => `${RoutePrefixes.EXTRANET}/notifications`,
        },
      },
      offices: {
        office: {
          generate: (): string => `${RoutePrefixes.EXTRANET}/office`,
        },
        officeWithBillingAddress: {
          generate: (officeId: string): string =>
            `${RoutePrefixes.EXTRANET}/office#billingAddress_${officeId}`,
        },
        balanceAndStatistics: {
          generate: (officeId?: string): string =>
            `${RoutePrefixes.EXTRANET}/balance-statistics/${officeId}`,
        },
        transactionModel: {
          list: {
            generate: (): string =>
              `${RoutePrefixes.EXTRANET}/transaction-model`,
          },
          signature: {
            generate: (): string =>
              `${RoutePrefixes.EXTRANET}/transaction-model/signature`,
          },
          scellement: {
            generate: (): string =>
              `${RoutePrefixes.EXTRANET}/transaction-model/scellement`,
          },
          positioning: {
            generate: (): string =>
              `${RoutePrefixes.EXTRANET}/transaction-model/positioning`,
          },
        },
        mailModel: {
          list: {
            generate: (): string => `${RoutePrefixes.EXTRANET}/model-mail`,
          },
          add: {
            generate: (type?: ModelMailTypes): string =>
              `${RoutePrefixes.EXTRANET}/model-mail/form${type ? `?type=${type}` : ""}`,
          },
          details: {
            generate: (id: string, type?: ModelMailTypes): string =>
              `${RoutePrefixes.EXTRANET}/model-mail/form/${id}${type ? `?type=${type}` : ""}`,
          },
        },
        contacts: {
          generate: (): string => `${RoutePrefixes.EXTRANET}/contacts`,
        },
        preferences: {
          generate: (): string => `${RoutePrefixes.EXTRANET}/preferences`,
        },
        cgu: {
          generate: (): string => `${RoutePrefixes.EXTRANET}/cgu`,
        },
        users: {
          generate: (): string => `${RoutePrefixes.EXTRANET}/administration`,
        },
        group: {
          generate: (): string => `${RoutePrefixes.EXTRANET}/group`,
        },
      },
    },
    signature: {
      generate: (signatoryId: string): string =>
        `${RoutePrefixes.EXTRANET}/signatory/${signatoryId}/success`,
    },
    officeTransfer: {
      confirmation: {
        generate: (shortcut: string): string =>
          `${RoutePrefixes.EXTRANET}/office-transfer/confirmation/${shortcut}`,
      },
      confirmed: {
        generate: (shortcut: string): string =>
          `${RoutePrefixes.EXTRANET}/office-transfer/confirmed/${shortcut}`,
      },
      refused: {
        generate: (shortcut: string): string =>
          `${RoutePrefixes.EXTRANET}/office-transfer/refused/${shortcut}`,
      },
      canceled: {
        generate: (shortcut: string): string =>
          `${RoutePrefixes.EXTRANET}/office-transfer/canceled/${shortcut}`,
      },
    },
    editors: {
      generate: (
        idRequest: string,
        shortcut: string,
        type: string,
        token?: string,
      ): string =>
        `${
          RoutePrefixes.EXTRANET
        }/editor/officeSelection/${idRequest}/${shortcut}/${type}${
          token ? `/${token}` : ""
        }`,
    },
    error: {
      generate: (): string => `${RoutePrefixes.EXTRANET}/error`,
    },
  },
  auth: {
    login: {
      generate: (options?: { callback?: string }): string => {
        const queries: Query[] = [];

        if (options?.callback !== undefined) {
          queries.push({ name: CALLBACK_URL_PARAM, value: options.callback });
        }

        return computePathWithQueries("/login", queries);
      },
    },
    logout: {
      generate: (): string => "/logout",
    },
  },
  cookie: {
    generate: (): string => "/cookies",
  },
  maintenance: {
    generate: (): string => "/maintenance",
  },
  e2e: {
    users: {
      generate: (): string => `${RoutePrefixes.E2E}/users`,
    },
  },
  error404: {
    generate: (): string => "/404",
  },
};
